// extracted by mini-css-extract-plugin
export default {"Root":"CanvasLayout_Root__rJE5a","Content":"CanvasLayout_Content__C2x8+"};